import LocationRepository from '@/models/Location/LocationRepository'

const getLocationsCacheable = () => {
  /**
   * Map<groupId, Location[]>の型で地点情報をキャッシュ
   * 2回目以降のアクセスはMapから値を返す
   */
  const locationsMap = new Map()

  return async (groupType, groupId) => {
    if (locationsMap.has(groupId)) {
      return locationsMap.get(groupId)
    }

    const locations = await LocationRepository.getList(groupType, groupId)

    locationsMap.set(groupId, locations)
    return locations
  }
}

export default getLocationsCacheable
